import React, {useEffect} from 'react';
import {classes, style} from './doppe-action-type-base-list-view-item.st.css';
import {ListViewItemRoot, reactCreateMemo, useDynamicRef, useWasVisibleInViewport} from '@wix/devzai-utils-react';
import {uiPartCreateMarking} from '@wix/devzai-utils-common';
import {DoppeListActionSettings} from '../../../../client-server-common';
import {IDoppeViewerActionContext} from '../../../../doppe-sdk';
import {DoppeActionTypeListViewItemParts} from '../doppe-action-type-list-view-item.ui-parts';
import {CommonClasses} from '@wix/devzai-common-client';

export const DoppeActionTypeBaseListViewItem = reactCreateMemo(function DoppeActionTypeBaseListViewItem<PROPS extends DoppeListActionSettings.WithItemClickBehaviour>(
    props: {
        actionContext?: IDoppeViewerActionContext<PROPS>;
        innerItemIndex: number;
        innerItemId: string;
        contentClassName?: string;
    } & React.HTMLAttributes<any>
) {
    const {
        actionContext,
        innerItemIndex,
        innerItemId,
        children,
        className,
        contentClassName,
        ...htmlAttributes
    } = props;


    const itemRootRef = useDynamicRef<HTMLDivElement>();
    const wasVisible = useWasVisibleInViewport(itemRootRef);

    useEffect(() => {
        if (wasVisible && actionContext) {
            actionContext.reportInnerItemViewed(innerItemId, innerItemIndex);
        }
    }, [wasVisible, actionContext, innerItemId, innerItemIndex]);

    return (
        <ListViewItemRoot
            {...htmlAttributes}
            elementRef={itemRootRef}
            className={style(classes.root, {}, className, CommonClasses.button)}
            {...uiPartCreateMarking(DoppeActionTypeListViewItemParts.ItemRoot, innerItemId)}
        >
            <div
                className={style(classes.actionTypeListViewItemViewRootContent, {}, contentClassName)}
            >
                {children}
            </div>
        </ListViewItemRoot>
);
});


